<template>
  <!-- <div v-show="show" class="backTop fvcd"> -->
  <div class="backTop fvcd" :style="{ opacity: opacity }">
    <span :class="{ active: active === 0 }" @click="onClickTab(0)">商品</span>
    <span :class="{ active: active === 1 }" @click="onClickTab(1)">详情</span>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { backTop } from '@/util'
import _ from 'lodash'

export default {
  setup() {
    const state = reactive({
      show: true,
      active: 0,
      opacity: 0
    })
    const onClickTab = data => {
      state.active = data
      if (data < 1) {
        backTop()
        state.opacity = 0
      }
    }

    onMounted(() => {
      let clientHeight = document.documentElement.clientHeight
      window.addEventListener(
        'scroll',
        _.throttle(async () => {
          let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
          let height = clientHeight * 0.3
          //滚动条的高度>可视区的高度
          // console.log(clientHeight, scrollTop, height, scrollTop > height, scrollTop > 300)
          state.show = scrollTop > height
          state.active = scrollTop > 300 ? 1 : 0
          if (scrollTop < height) {
            state.opacity = 0
          } else {
            state.opacity = (scrollTop - 300) / 150 > 1 ? 1 : (scrollTop - 300) / 150
          }
        }, 500),
        true
      )
    })
    return {
      ...toRefs(state),
      backTop,
      onClickTab
    }
  }
}
</script>

<style lang="scss" scoped>
.backTop {
  position: fixed;
  left: 0;
  right: 0;
  top: 80px;
  z-index: 99;
  background-color: #fff;
  span {
    padding: 10px;
    margin: 0 20px;
    border-bottom: 2px solid transparent;
  }
  .active {
    border-bottom: 2px solid #3088c5;
  }
}
</style>
